<div class="notif-overlay-section">
  <div>
    @if (notificationData.notifications.length > 0) {
      <mat-list>
        @for (notification of notificationData.notifications; track notification) {
          <mat-list-item class="notifList" (click)="notificationClick(notification);">
            @if (notification.status == 'SUCCESS') {
              <mat-icon style="color:green;" mat-list-icon>check_circle</mat-icon>
            }
            @if (notification.status == 'PENDING') {
              <mat-icon style="color:orange;" mat-list-icon>query_builder</mat-icon>
            }
            @if (notification.status == 'ERROR') {
              <mat-icon style="color:red;" mat-list-icon>error</mat-icon>
            }
            <h4 mat-line>{{notification.message}}</h4>
          </mat-list-item>
        }
      </mat-list>
    }
    @if (notificationData.notifications.length <= 0) {
      <mat-list>
        <mat-list-item (click)="$event.stopPropagation()">
          <mat-icon mat-list-icon>notifications_off</mat-icon>
          <h4 mat-line>No New Notifications</h4>
        </mat-list-item>
      </mat-list>
    }
    @if (notificationData.notifications.length > 0) {
      <mat-paginator (click)="$event.stopPropagation()" (page)="pageChanged($event)"
        [length]="notificationData.totalNumberOfRecords" [pageSize]="maxNoOfRecords" [hidePageSize]="true">
      </mat-paginator>
    }

    <mat-divider></mat-divider>
    <div style="text-align: center">
      <button style="margin: 10px auto" mat-button color="primary" (click)="footerBtnClicked()">View All</button>
    </div>
  </div>
</div>
